var icon = require('vue-svgicon')

icon.register({
    'example': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: ``
    },
    'heart': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path fill="#00AE66" d="M25.875,4.139c-3.378-1.712-7.37-0.346-9.239,3.035c-0.001,0.002-0.001,0.002-0.002,0.003
          c-0.005,0.011-0.01,0.02-0.017,0.029c-0.001,0.006-0.004,0.01-0.005,0.012c-0.128,0.219-0.354,0.363-0.612,0.363
          c-0.258,0-0.483-0.144-0.611-0.363c-0.002-0.002-0.004-0.006-0.006-0.012c-0.006-0.009-0.012-0.018-0.017-0.029
          c0-0.001,0-0.001-0.001-0.003c-1.867-3.382-5.86-4.748-9.239-3.035c-3.589,1.816-5.129,6.42-3.438,10.279
          c1.335,3.047,8.849,10.578,11.961,13.62h0.003c0.355,0.349,0.828,0.562,1.35,0.562c0.518,0,0.989-0.211,1.346-0.557
          c3.108-3.037,10.63-10.575,11.967-13.625C31.005,10.56,29.466,5.956,25.875,4.139L25.875,4.139z M25.875,4.139" />`
    },
    'heart-hollow': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path fill="#00ae66" d="M16 28.5c-.571 0-1.239-.302-1.468-.72-.796-.687-4.327-4.141-10.512-10.284l-.098-.098C2.353 15.645 1.5 13.611 1.5 11.652c0-2.06.928-4.261 2.422-5.745C5.484 4.354 7.536 3.5 9.7 3.5s4.215.854 5.777 2.407c.179.177.36.357.523.542.163-.185.343-.363.52-.539 1.565-1.555 3.617-2.41 5.78-2.41 2.164 0 4.216.854 5.777 2.407C29.64 7.458 30.5 9.499 30.5 11.652s-.86 4.193-2.423 5.747c-6.258 6.219-9.809 9.692-10.609 10.382-.23.417-.897.719-1.468.719zm-.558-1.181c.108.076.335.181.558.181.218 0 .439-.101.55-.176v-.116l.225-.147c.367-.268 4.412-4.225 10.551-10.324 1.419-1.411 2.175-3.2 2.175-5.084s-.756-3.673-2.128-5.036C26 5.251 24.198 4.5 22.3 4.5c-1.897 0-3.699.751-5.072 2.116-.317.316-.643.64-.781.914L16 8.421l-.447-.892c-.138-.275-.462-.598-.777-.91C13.399 5.251 11.598 4.5 9.7 4.5S6 5.251 4.627 6.616C3.335 7.9 2.5 9.876 2.5 11.652c0 1.713.763 3.51 2.147 5.059l.078.075c6.206 6.164 10.133 10.007 10.506 10.278l.206.149.005.106z" />
          <path fill="#00ae66" d="M22.3 6c1.499 0 2.925.597 4.015 1.68C27.402 8.759 28 10.17 28 11.652s-.598 2.893-1.685 3.973l-.043.042C19.81 22.088 16.784 25.032 16 25.746c-.777-.709-3.809-3.656-10.272-10.077C4.613 14.406 4 12.981 4 11.652c0-1.396.661-2.956 1.685-3.973C6.775 6.596 8.201 6 9.7 6s2.925.597 4.016 1.68c.176.175.442.44.497.523a2.003 2.003 0 0 0 1.78 1.115c.756 0 1.44-.413 1.78-1.089.069-.109.335-.373.512-.549C19.375 6.596 20.801 6 22.3 6zm0-2c-2.1 0-4.025.87-5.425 2.261-.35.348-.7.695-.875 1.044-.175-.348-.525-.696-.875-1.044C13.725 4.87 11.8 4 9.7 4s-4.025.87-5.425 2.261S2 9.739 2 11.652s.875 3.826 2.275 5.392C5.5 18.261 14.425 27.131 14.95 27.478c0 .174.525.522 1.05.522s1.05-.348 1.05-.522c.525-.348 9.45-9.217 10.675-10.434 1.4-1.392 2.275-3.305 2.275-5.392s-.875-4-2.275-5.391S24.4 4 22.3 4z" />`
    },
    'phone': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<g>
            <path fill="none" d="M-171.5-276.5c0-14.359-11.641-26-26-26s-26,11.641-26,26c0,6.584,2.452,12.592,6.487,17.173
        c-0.481,1.416-0.486,2.633-0.486,2.633s9.92,8.194,20.261,8.194c9.634,0,19.739-8.196,19.739-8.196
        c0.008-1.007-0.143-1.906-0.425-2.701C-173.928-263.97-171.5-269.95-171.5-276.5z" />
        </g>
        <g>
            <g>
                <circle fill="#E7F7F0" cx="16" cy="16" r="14" />
            </g>
        </g>
        <g>
            <path fill="#00AE66" d="M11.397,10.05L11.397,10.05c0.093,0,0.35,0.124,0.724,0.589c0.601,0.749,0.776,1.083,0.825,1.219
        c-0.073,0.089-0.217,0.231-0.328,0.34l-0.161,0.159c-0.473,0.472-0.832,1.349,0.142,2.846c0.414,0.637,1.047,1.377,1.934,2.264
        c1.786,1.785,2.966,2.546,3.946,2.546c0.453,0,0.854-0.162,1.164-0.47l0.16-0.161c0.11-0.111,0.252-0.255,0.341-0.329
        c0.136,0.05,0.471,0.224,1.219,0.826c0.562,0.452,0.588,0.693,0.589,0.719c0.01,0.232-0.492,0.709-0.792,0.993
        c-0.103,0.098-0.203,0.194-0.289,0.28c-0.03,0.022-0.174,0.079-0.467,0.079c-1.413,0-4-1.162-6.595-3.756
        c-3.559-3.56-4.019-6.587-3.686-7.054c0.094-0.094,0.19-0.195,0.288-0.298C10.69,10.546,11.162,10.05,11.397,10.05 M11.397,9
        c-0.812,0-1.455,0.833-2.019,1.397c-1.014,1.015-0.053,4.798,3.686,8.538C15.889,21.76,18.739,23,20.402,23
        c0.539,0,0.953-0.13,1.201-0.379c0.88-0.879,2.417-1.951,0.416-3.56c-0.965-0.776-1.513-1.075-1.925-1.075
        c-0.441,0-0.724,0.345-1.195,0.815c-0.112,0.112-0.255,0.163-0.421,0.163c-0.774,0-2.063-1.099-3.203-2.239
        c-1.386-1.385-2.711-2.99-2.076-3.624c0.907-0.908,1.348-1.117-0.26-3.119C12.361,9.263,11.852,9,11.397,9L11.397,9z" />
        </g>`
    },
    'sms': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<g>
            <path fill="none" d="M-171.5-276.5c0-14.359-11.641-26-26-26s-26,11.641-26,26c0,6.584,2.452,12.592,6.487,17.173
        c-0.481,1.416-0.486,2.633-0.486,2.633s9.92,8.194,20.261,8.194c9.634,0,19.739-8.196,19.739-8.196
        c0.008-1.007-0.143-1.906-0.425-2.701C-173.928-263.97-171.5-269.95-171.5-276.5z" />
        </g>
        <g>
            <g>
                <path fill-rule="evenodd" clip-rule="evenodd" fill="#E5F7EF" d="M16,2c7.732,0,14,6.268,14,14c0,7.732-6.268,14-14,14
            S2,23.732,2,16C2,8.268,8.268,2,16,2z" />
            </g>
            <g>
                <path fill="#00AE66" d="M15.992,17.559c-0.398,0-0.793-0.145-1.094-0.431l-5.254-5.671l0.771-0.714l5.23,5.647
            c0.182,0.172,0.53,0.172,0.736-0.023l5.01-5.41l0.77,0.714l-5.033,5.433C16.809,17.408,16.398,17.559,15.992,17.559z" />
                <g>
                    <path fill="#00AE66" d="M21.6,11.8L21.6,11.8v8.4l-11.2,0l0-8.4H21.6 M21.6,10.75H10.4c-0.58,0-1.05,0.47-1.05,1.05v8.4
                c0,0.58,0.47,1.05,1.05,1.05h11.2c0.58,0,1.05-0.47,1.05-1.05v-8.4C22.65,11.22,22.18,10.75,21.6,10.75L21.6,10.75z" />
                </g>
            </g>
        </g>`
    },
    'triangle': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path fill="#ccc" d="M2 8.588h28L15.176 23.412 2 8.588z" />`
    },
    'arrow': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `
          <path fill="#00ae66" d="M23.197 3.161c-0.385-0.378-1.008-0.378-1.392 0l-12.532 12.324c-0.385 0.379-0.385 0.991 0 1.37 0.384 0.377 1.008 0.377 1.392 0l12.532-12.326c0.384-0.377 0.384-0.992 0-1.368z"></path>
      <path fill="#00ae66" d="M9.969 17.521c-0.364 0-0.707-0.14-0.965-0.394-0.259-0.255-0.402-0.595-0.402-0.957s0.143-0.702 0.402-0.958l12.532-12.324c0.518-0.508 1.412-0.508 1.93 0 0.259 0.253 0.401 0.592 0.402 0.955 0 0.363-0.143 0.704-0.402 0.96l-12.532 12.325c-0.259 0.254-0.601 0.393-0.965 0.393zM22.501 3.259c-0.162 0-0.313 0.062-0.428 0.174l-12.532 12.325c-0.112 0.11-0.174 0.257-0.174 0.412s0.062 0.301 0.174 0.412c0.228 0.223 0.627 0.223 0.856 0l12.532-12.325c0.112-0.11 0.174-0.257 0.174-0.413s-0.062-0.3-0.173-0.409c-0.116-0.114-0.267-0.176-0.429-0.176z"></path>
      <path fill="#00ae66" d="M23.146 29.588c0.378-0.385 0.378-1.009 0-1.394l-12.312-12.545c-0.378-0.385-0.99-0.385-1.369 0-0.377 0.385-0.377 1.009 0 1.394l12.313 12.545c0.378 0.385 0.993 0.385 1.368 0z"></path>
      <path fill="#00ae66" d="M22.463 30.259c-0.362 0-0.702-0.143-0.957-0.403l-12.313-12.546c-0.521-0.531-0.522-1.396 0-1.929 0.513-0.521 1.403-0.521 1.915-0.001l12.312 12.547c0.522 0.531 0.522 1.397 0 1.93-0.254 0.26-0.594 0.402-0.957 0.402zM10.15 15.743c-0.155 0-0.301 0.062-0.412 0.174-0.231 0.236-0.231 0.621 0 0.857l12.314 12.546c0.22 0.224 0.603 0.225 0.82 0 0.232-0.237 0.232-0.621 0-0.857l-12.31-12.546c-0.111-0.112-0.257-0.174-0.412-0.174z"></path>
    `
    },
    'user': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        defaultColor: ['#00ae66 #00ae66', '#3478f1 #3478f1'],
        data: `<path fill="#fff" d="M15.594 8.248c2.553 0 4.63 1.977 4.63 4.408s-2.077 4.408-4.63 4.408-4.63-1.977-4.63-4.408c-0.001-2.43 2.077-4.408 4.63-4.408zM15.594 6.542c-3.5 0-6.337 2.738-6.337 6.114 0 3.377 2.837 6.114 6.337 6.114s6.337-2.737 6.337-6.114c-0.001-3.376-2.838-6.114-6.337-6.114v0z"></path><path fill="#fff" d="M10.263 21.014c0.021-0.018 0.038-0.037 0.059-0.055 0.101-0.084 0.209-0.158 0.314-0.237 0.055-0.041 0.108-0.085 0.165-0.124 0.18-0.127 0.367-0.246 0.558-0.359 0.015-0.009 0.030-0.019 0.045-0.028 0.213-0.124 0.433-0.239 0.658-0.344 0.002-0.001 0.003-0.002 0.005-0.002 0.224-0.104 0.453-0.199 0.687-0.285 0.010-0.004 0.020-0.008 0.031-0.012 0.214-0.077 0.432-0.145 0.653-0.206 0.037-0.010 0.072-0.023 0.11-0.033 0.194-0.051 0.391-0.092 0.589-0.13 0.067-0.013 0.133-0.030 0.201-0.042 0.175-0.030 0.353-0.050 0.531-0.070 0.092-0.010 0.182-0.026 0.275-0.034 0.219-0.018 0.441-0.025 0.664-0.029 0.048-0.001 0.094-0.006 0.142-0.006 0.002 0 0.003 0 0.005 0s0.004 0 0.005 0c2.13 0 4.131 0.689 5.637 1.94 0.348 0.289 0.648 0.607 0.921 0.937 0.076 0.089 0.153 0.176 0.224 0.268 0.023 0.030 0.043 0.061 0.065 0.092 0.67 0.9 1.113 1.937 1.246 3.055h1.561c-0.167-4.44-4.419-7.998-9.654-7.998s-9.487 3.558-9.653 7.998h1.539c0.198-1.678 1.088-3.18 2.417-4.296z"></path>`
    },
    'search': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path fill="#666" d="M23.457 23.045l6.251 6.252-1.414 1.414-6.251-6.252 1.414-1.414zM14.882 27.277c-6.835 0-12.396-5.562-12.396-12.396S8.047 2.485 14.882 2.485s12.396 5.561 12.396 12.396-5.561 12.396-12.396 12.396zm0-22.792c-5.732 0-10.396 4.664-10.396 10.396S9.15 25.277 14.882 25.277s10.396-4.664 10.396-10.396S20.614 4.485 14.882 4.485z" />`
    },
    'secondhandhouse': { // 二手房
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<g>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#44C288" d="M16,2c7.732,0,14,6.268,14,14s-6.268,14-14,14S2,23.732,2,16
        S8.268,2,16,2z" />
            <g>
                <path fill-rule="evenodd" clip-rule="evenodd" fill="#44C288" d="M14.542,20.147h2.917v1.75h-2.917V20.147z" />
                <g>
                    <path fill="#FFFFFF" d="M17.458,17.522v3.5h-2.917v-3.5H17.458 M17.75,16.647h-3.5c-0.322,0-0.583,0.261-0.583,0.583v4.667h4.667
            V17.23C18.333,16.908,18.072,16.647,17.75,16.647L17.75,16.647z" />
                </g>
                <g>
                    <path fill="#FFFFFF" d="M15.97,11.149l5.015,3.307v6.565h-9.971v-6.636L15.97,11.149 M15.973,10.103l-5.833,3.81v7.984h11.721
            v-7.911L15.973,10.103L15.973,10.103z" />
                </g>
            </g>
            <rect x="14.542" y="20.261" fill-rule="evenodd" clip-rule="evenodd" fill="#44C288" width="2.912" height="1.65" />
        </g>`
    },
    'newhouse': { // 二手房
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<g>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#F47E4B" d="M16,2c7.732,0,14,6.268,14,14s-6.268,14-14,14S2,23.732,2,16
        S8.268,2,16,2z" />
            <path fill="#FFFFFF" d="M18.622,16.142l2.045,0.316v4.411v0.089h-2.045V16.142 M17.747,15.122v6.712h3.795c0-0.829,0-0.964,0-0.964
        s0,0.002,0,0.006v-5.167L17.747,15.122L17.747,15.122z" />
            <path fill="#FFFFFF" d="M17.75,11.308l0.003,9.65h-6.42v-0.581v-7.341L17.75,11.308 M18.625,10.166l-8.167,2.2v8.011
        c0,0.804,0,0.532,0,1.456h8.17L18.625,10.166L18.625,10.166z" />
            <g>
                <g>
                    <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M12.792,17.167h1.167V16h-1.167V17.167z M12.792,15.125h1.167
            v-1.167h-1.167V15.125z M14.833,13.958v1.167H16v-1.167H14.833z" />
                </g>
            </g>
        </g>`
    },
    'renthouse': { // 租房
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<g>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#E7D159" d="M16,2c7.732,0,14,6.268,14,14s-6.268,14-14,14S2,23.732,2,16
        S8.268,2,16,2z" />
            <g>
                <g>
                    <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M17.75,22.417v0.875h1.167v-0.875H17.75z M13.083,23.292h1.167
            v-0.875h-1.167V23.292z" />
                </g>
            </g>
            <path fill="#FFFFFF" d="M19.316,13.501h-6.632v-3.312c0-0.755,0.702-1.37,1.565-1.37h3.5c0.863,0,1.566,0.615,1.566,1.37V13.501z
         M13.482,12.704h5.035v-2.515c0-0.31-0.352-0.572-0.768-0.572h-3.5c-0.416,0-0.768,0.262-0.768,0.572V12.704z" />
            <path fill="#FFFFFF" d="M19.5,22.854h-7c-1.206,0-2.188-0.981-2.188-2.188v-5.833c0-1.206,0.981-2.188,2.188-2.188h7
        c1.206,0,2.188,0.981,2.188,2.188v5.833C21.688,21.873,20.706,22.854,19.5,22.854z M12.5,13.521c-0.724,0-1.312,0.589-1.312,1.312
        v5.833c0,0.724,0.589,1.312,1.312,1.312h7c0.724,0,1.312-0.589,1.312-1.312v-5.833c0-0.724-0.589-1.312-1.312-1.312H12.5z" />
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M13.667,15.708h0.875v4.375h-0.875V15.708z" />
            <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M17.458,15.708h0.875v4.375h-0.875V15.708z" />
        </g>`
    }
})
